import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Footer from '../../../components/Sections/Footer/Footer';
import TopNavbar from "../../../components/Nav/TopNavbar";
import '../../../screens/Jobs/jobs.css';
import cp_header from '../../../assets/jobs/CP_Header.png'
import frame from '../../../assets/jobs/frame.png'
import frame2 from '../../../assets/jobs/frame2.png';
import Job_Listing from '../../../assets/jobs/JobListing.png'
import styled from "styled-components";
import { Box, Button, Tooltip, Typography } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import UploadFileIcon from "@mui/icons-material/UploadFile";


export default function JobListing() {
    const [open, setOpen] = useState(false);
    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState("Upload Your CV");
    const [message, setMessage] = useState("");
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        contactNumber: "",
    });

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const copyUrl = () => {
        navigator.clipboard.writeText(window.location.href)
            .then(() => {
                setOpen(true); // Show tooltip
                setTimeout(() => setOpen(false), 2000); // Hide tooltip after 2 seconds
            })
            .catch((err) => console.error("Failed to copy URL:", err));
    };


    const handleSubmit = (e) => {
        e.preventDefault();

        // Validation
        if (!formData.fullName || !formData.email || !formData.contactNumber) {
            setMessage("All fields are required.");
            return;
        }
        if (!/\S+@\S+\.\S+/.test(formData.email)) {
            setMessage("Please enter a valid email address.");
            return;
        }
        if (!/^\d{10,15}$/.test(formData.contactNumber)) {
            setMessage("Contact number must be 10 to 15 digits.");
            return;
        }

        // Simulate form submission
        const formPayload = {
            ...formData,
            cv: selectedFile,
        };

        console.log("Form submitted:", formPayload);

        // Success message
        setMessage("Your application has been submitted successfully!");
        setFormData({ fullName: "", email: "", contactNumber: "" });
        setFileName("Upload your CV here");
        setSelectedFile(null);
    };

    // Handle input change
    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value,
        }));
    };

    // Handle file change
    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFileName(file.name);
            setSelectedFile(file);
        }
    };

    return (
        <>
            <TopNavbar />
            <div className="job-listing">
                <div className="container-fluid p-0 bg-purple">
                    <div className="row m-0 section1-banner-container bg-purple"
                        style={{
                            backgroundImage: `url(${cp_header})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                        }}>
                        <div className="col-12 p-0 pb-5 pt-5"
                            style={{
                                backgroundImage: `url(${Job_Listing})`,
                                backgroundSize: 'cover',
                                backgroundRepeat: 'no-repeat',
                            }}>
                            <div className="d-flex flex-column justify-content-start align-items-start px-3 px-md-5 py-5 my-5 position-relative">
                                <h1 className="text-white pt-1 pl-3 banner-heading" style={{ fontSize: "70px" }} >FRONTEND DEVELOPER</h1>
                                <div className="row">
                                    <div className="col-lg-12 mt-3">
                                        <span className="banner-paragraph text-white pl-3 my-4">Karachi, Pakistan</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div
                        style={{
                            backgroundImage: `url(${frame})`,
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundColor: "#D5D0EF",
                        }}>
                        <div className="row py-4 px-4 py-4">
                            <div className="col-lg-4">
                                <div className="info-card border rounded p-4">
                                    <div className="my-4 py-2">
                                        <h5 className="listing-heading fw-bold">Location</h5>
                                        <p className="listing-text">Karachi, Pakistan</p>
                                    </div>

                                    <hr />

                                    <div className="my-4 py-2">
                                        <h5 className="listing-heading fw-bold">Salary</h5>
                                        <p className="listing-text">£45000 - £65000 per annum +<br /> Bonus + Pension + Benefits</p>
                                    </div>

                                    <hr />

                                    <div className="my-4 py-2">
                                        <h5 className="listing-heading fw-bold">Job Type</h5>
                                        <p className="listing-text">Hybrid, Permanent</p>
                                    </div>
                                </div>

                                <div className="info-card border rounded mt-4 p-4">

                                    <div className="my-4 py-2">
                                        <h5 className="listing-heading fw-bold">Reference</h5>
                                        <p className="listing-text">#FDMAN2038-234</p>
                                    </div>
                                </div>

                                <ButtonInput type="submit" value="Back" className="pointer animate radius8 mt-4" style={{ maxWidth: "180px" }} />

                            </div>

                            <div className="col-lg-8">
                                <div className="d-flex justify-content-between" > <h3 className="mt-1 mb-2 listing-heading">Description</h3>
                                    <Tooltip
                                        open={open}
                                        title="Copied URL!"
                                        arrow
                                        placement="top"
                                        onClose={() => setOpen(false)}
                                    >
                                        <Button
                                            variant="outlined"
                                            onClick={copyUrl}
                                            startIcon={<ContentCopyIcon />}
                                            sx={{
                                                borderColor: "#160A54", // Custom border color
                                                color: "#160A54",       // Custom font color
                                                "&:hover": {
                                                    borderColor: "#160A54",
                                                    backgroundColor: "#f5f5f5", // Optional hover background color
                                                },
                                            }}
                                        >
                                            Share
                                        </Button>
                                    </Tooltip>
                                </div>
                                <h5 className="mb-1 listing-heading fw-bold">Front End Developer</h5>
                                <h5 className="mb-3 mt-2 listing-heading fw-bold">UK Leading Ecommerce Firm – Manchester – Hybrid</h5>
                                <div>
                                    <p className="mb-3 listing-text">
                                        (Tech stack: Front End Developer, React, ReactJS 18, React Hooks, React.js, Shopify platform, JavaScript, TypeScript, HTML, CSS, UI, UX, User Interface, User Experience, Javascript Developer, Front End Engineer, Front End Developer)
                                    </p>
                                    <p className="mb-3 listing-text">
                                        ith experience in React and Shopify platform. You will be responsible for predominantly implementing new Figma designs and functionality to the Shopify store, through fluent, maintainable code. You will work alongside designers within the creative team, and other senior members on multiple technical projects.
                                    </p>
                                    <p className="mb-3 listing-text">
                                        My client is looking for Front End Developers who has current and relevant experience working with React and Shopify platform. You will be building new pages, features and functionality on the Ecommerce site. You will also discover and debug issues and ensure the consistent quality and UX across all devices and browsers.
                                    </p>
                                    <p className="mb-3 listing-text">
                                        Our client is looking for passionate Front End Developers with experience in some or all of the following (full training will be provided to fill any gaps in your skill set): React, ReactJS 18, React Hooks, React.js, Shopify platform, JavaScript, TypeScript, HTML, CSS, GIT, API’s, UI, UX, User Interface, User Experience.
                                    </p>
                                </div>

                                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 ml-0 mt-4">
                                    <h5 className="my-3 listing-heading fw-bold">Apply For This Role</h5>
                                    <label htmlFor="fullName" style={{ fontSize: "13px", color: '#160A54' }} >Full Name</label>
                                    <input
                                        type="text"
                                        id="fullName"
                                        className="custom-input"
                                        value={formData.fullName}
                                        onChange={handleInputChange}
                                    />
                                    <label className="mt-2" htmlFor="Email" style={{ fontSize: "13px", color: '#160A54' }}>Email</label>
                                    <input
                                        type="text"
                                        id="email"
                                        className="custom-input"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                    />
                                    <label className="mt-2" htmlFor="ContactNumber" style={{ fontSize: "13px", color: '#160A54' }}>Contact Number</label>
                                    <input
                                        type="text"
                                        id="contactNumber"
                                        className="custom-input"
                                        value={formData.contactNumber}
                                        onChange={handleInputChange}
                                    />
                                    <Box
                                        sx={{
                                            backgroundColor: "#FFF",
                                            borderRadius: 2,
                                            boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
                                            textAlign: "center",

                                        }}
                                        className="custom-input mb-3 mt-3"
                                    >
                                        <label htmlFor="upload-cv" style={{ cursor: "pointer", display: "block" }}>
                                            <label className="my-4" htmlFor="ContactNumber" style={{ fontSize: "15px", color: '#160A54' }}>
                                                {fileName}
                                            </label>
                                        </label>
                                        <input
                                            id="upload-cv"
                                            type="file"
                                            onChange={handleFileChange}
                                            accept=".pdf,.doc,.docx"
                                            style={{ display: "none" }}
                                        />
                                    </Box>
                                    <ButtonInput type="submit" value="Send Message" className="pointer animate radius8" style={{ maxWidth: "220px" }} />

                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
}


const ButtonInput = styled.input`
  border: 1px solid #160A54;
  background-color: #160A54;
  width: 100%;
  padding: 10px;
  outline: none;
  color: #fff;
  :hover {
    background-color: #160A54;
    border: 1px solid #160A54;
    color: #fff;
  }
  @media (max-width: 991px) {
    margin: 0 auto;
  }
`;